import { z } from "zod";
import { NumberOrNaN } from "./zod/utils.js";

import { DatetimeValue } from "./datetimeType.js";
import { FileTypeLiteral } from "./enums.js";
import { AppSessionFileId, FileId } from "./idTypeBrands.js";
import { TableInputData } from "./tableInputTypes.js";
import { JsonSerializedParameterValueContents } from "./typeBrands.js";

export const AllowedDynamicListValueTypes = z.union([
  z.string(),
  NumberOrNaN,
  z.boolean(),
  z.null(),
]);
export type AllowedDynamicListValueTypes = z.infer<
  typeof AllowedDynamicListValueTypes
>;

export const DynamicList = z.array(AllowedDynamicListValueTypes);
export type DynamicList = z.infer<typeof DynamicList>;

export const StringArray = z.array(z.string());
export type StringArray = z.infer<typeof StringArray>;

export const NumberArray = z.array(NumberOrNaN);
export type NumberArray = z.infer<typeof NumberArray>;

export const DatetimeValueTuple = z.tuple([DatetimeValue, DatetimeValue]);
export type DatetimeValueTuple = z.infer<typeof DatetimeValueTuple>;

export const FileUpload = z.object({
  id: z.union([FileId, AppSessionFileId]),
  name: z.string(),
  type: FileTypeLiteral,
});
export type FileUpload = z.infer<typeof FileUpload>;

export const UserAttributes = z.record(z.string(), z.string());
export type UserAttributes = z.infer<typeof UserAttributes>;

export const ParameterValueContents = z.union([
  z.string(),
  z.boolean(),
  z.null(),
  NumberOrNaN,
  StringArray,
  NumberArray,
  DynamicList,
  TableInputData,
  DatetimeValue,
  DatetimeValueTuple,
  FileUpload,
  UserAttributes,
]);
export type ParameterValueContents = z.infer<typeof ParameterValueContents>;

export const parseJsonSerializedParameterValueContents = (
  contents: JsonSerializedParameterValueContents,
): ParameterValueContents => {
  try {
    return JSON.parse(contents);
  } catch (err) {
    console.error(err);
    throw new Error(`Invalid serialized parameter value`);
  }
};

export const serializeParameterValueContents = (
  contents: ParameterValueContents,
): JsonSerializedParameterValueContents => {
  return JSON.stringify(contents) as JsonSerializedParameterValueContents;
};
